import React from 'react'
import { connect } from 'react-redux'

import { getIdentityLastUserActivity } from 'store/entities/identity/selectors'
import UserStoryForm from 'app/domains/common/UserStoryForm'
import { setYesterdayStory } from 'store/entities/identity/actions'
import { CREATE_STORY_FORM_NAME as FORM_NAME } from 'app/constants/activities'
import UniversalPopover from 'app/domains/common/UniversalPopover'
import NoteQuotes from 'app/components/NoteQuotes'

const mapStateToPropsNote = state => ({
  proQuote: getIdentityLastUserActivity(state).get('proQuote'),
  proQuoteAuthor: getIdentityLastUserActivity(state).get('proQuoteAuthor'),
  description: getIdentityLastUserActivity(state).get('description'),
  activityDay: getIdentityLastUserActivity(state).get('day'),
  protrackName: getIdentityLastUserActivity(state).get('protrackName'),
})

const Note = connect(mapStateToPropsNote)(NoteQuotes)

const Title = () => {
  return (
    <UniversalPopover body={<Note />}>
      <span style={{ color: '#2ed8a7', cursor: 'pointer' }}>previous day's</span>
    </UniversalPopover>
  )
}

const mapStateToProps = state => ({
  question: getIdentityLastUserActivity(state).get('question'),
  activityId: getIdentityLastUserActivity(state).get('id'),
  userActivityId: getIdentityLastUserActivity(state).get('userActivityId'),
  form: `${FORM_NAME}ForYesterdayActivity`,
  title: <Title />,
})

const mapDispatchToProps = {
  setYesterdayStory,
}

export default connect(mapStateToProps, mapDispatchToProps)(UserStoryForm)
